import { render } from "./vue-custom-viviendas-catalogo-component.vue?vue&type=template&id=1adcfd64"
import script from "./vue-custom-viviendas-catalogo-component.vue?vue&type=script&lang=js"
export * from "./vue-custom-viviendas-catalogo-component.vue?vue&type=script&lang=js"

import "./vue-custom-viviendas-catalogo-component.vue?vue&type=style&index=0&id=1adcfd64&lang=css"

import exportComponent from "C:\\users\\siste\\source\\repos\\dilsistemas\\Dil_Pagina\\Dil_Pagina\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__